import { ActivatedRoute } from "@angular/router";
import { DataType } from "./enums";
import { ResponseData } from "./response";
import { HttpErrorResponse } from "@angular/common/http";
import { HttpStatusCode } from "./httpCode";
import { appInjector } from "./app-injector";
import { AuthGuard } from "../components/auth/auth.guard";

export function getErrorMessage(error: HttpErrorResponse): string {
  try {
    if (JSON.stringify(error.error) === '{"isTrusted":true}') {
      return "Servidor no disponible";
    }

    if (error.status == HttpStatusCode.NotFound) {
      return `Error 404, metodo ${error.url
        .split("/")
        .slice(3)
        .join("/")} no encontrado`;
    }

    const errorJson = error.error;

    if (isUnauthorized(error)) {
      setTimeout(() => {
        try {
          const guard = appInjector().get(AuthGuard);

          if (!guard.checkDisabled()) {
            guard.logout();
          }
        } catch (e) {}
      });

      if (errorJson) {
        return errorJson.Message;
      }

      return "Error validando el token de autenticaciÃ³n";
    } else if (errorJson) {
      if (errorJson.Message) {
        return errorJson.Message;
      }

      if (errorJson.errors) {
        let message = "";

        for (const property in errorJson.errors) {
          message += errorJson.errors[property].join(", ");
        }

        return message;
      }
    }

    return JSON.stringify(error.error) || "Error desconocido";
  } catch (err) {
    return `${error.url
      .split("/")
      .slice(3)
      .join("/")}, ${error.statusText}`;
  }
}

export function isUnauthorized(error: HttpErrorResponse): boolean {
  if (error.status === HttpStatusCode.Unauthorized) {
    return true;
  }

  try {
    return JSONisUnauthorized(error.error);
  } catch (e) {
    return false;
  }
}

export function JSONisUnauthorized(error: ResponseData): boolean {
  if (error && error.HttpCode === HttpStatusCode.Unauthorized) {
    return true;
  }

  return false;
}

export function sumArray(items, prop): number {
  if (items == null) {
    return 0;
  }

  return items.reduce(function(a, b) {
    return b[prop] == null ? a : a + b[prop];
  }, 0);
}

export function resetFormControls(form: any) {
  if (form) {
    for (const ctlr in form.controls) {
      form.controls[ctlr].setErrors(null);
      form.controls[ctlr].markAsPristine({ onlySelf: true });
      form.controls[ctlr].markAsUntouched({ onlySelf: true });
    }
  }
}

export function replicate(
  num: number,
  charReplicate: string = "0",
  padding: string = "l",
  size: number = 2
): string {
  let number: string = String(num);

  if (number.length === size) {
    return number;
  }

  while (number.length < size) {
    number = padding === "l" ? charReplicate + number : number + charReplicate;
  }

  return number;
}

export function replicateString(
  num: number,
  charReplicate: string = "0"
): string {
  let number = "";

  for (let i = 1; i <= num; i++) number += charReplicate;

  return number;
}

export function floatToString(flt: number): string {
  const rx = /^([\d.]+?)e-(\d+)$/,
    fStr = flt.toString();
  let details, num, cnt;

  if (rx.test(fStr)) {
    details = rx.exec(fStr);
    num = details[1];
    cnt = parseInt(details[2], 10);
    cnt += num.replace(/\./g, "").length - 1; // Adjust for longer numbers

    return flt.toFixed(cnt);
  }

  return fStr;
}

export function getRandomNumber(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function createBreadcrumbs(currentRoute: ActivatedRoute): Array<Object> {
  const breadcrumbs = [];

  let url = "",
    previousRoute;

  do {
    const childrenRoutes = currentRoute.children;
    currentRoute = null;

    childrenRoutes.forEach(child => {
      if (child.outlet === "primary") {
        const routeSnapshot = child.snapshot;

        url += `/${routeSnapshot.url.map(segment => segment.path).join("/")}`;

        if (!previousRoute) {
          previousRoute = { label: child.snapshot.data, url: url };

          breadcrumbs.push(previousRoute);
        } else {
          if (previousRoute["label"].title != child.snapshot.data.title) {
            let label = child.snapshot.data;

            if (
              (!label.title || label.title == "") &&
              (child.snapshot.routeConfig.path == "add" ||
                child.snapshot.routeConfig.path == "edit")
            ) {
              label = { title: child.snapshot.routeConfig.path };

              if (breadcrumbs.length > 0) {
                const previous = breadcrumbs[breadcrumbs.length - 1];

                if (
                  previous["url"].substring(previous["url"].length - 1) != "/"
                ) {
                  previous["url"] += "/";
                }
              }
            }

            previousRoute = { label: label, url: url };
            breadcrumbs.push(previousRoute);
          }
        }
        currentRoute = child;
      }
    });
  } while (currentRoute);

  return breadcrumbs;
}

export function toInteger(value) {
  return parseInt("" + value, 10);
}

export function toString(value) {
  return value && value !== null ? "" + value : "";
}

export function getValueInRange(value, max, min) {
  if (min === void 0) {
    min = 0;
  }
  return Math.max(Math.min(value, max), min);
}

export function isString(value) {
  return typeof value === "string";
}

export function isEmpty(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export function isNumber(value) {
  return !isNaN(toInteger(value));
}

export function isInteger(value) {
  return (
    typeof value === "number" && isFinite(value) && Math.floor(value) === value
  );
}

export function isDefined(value) {
  return value && value !== null;
}

export function padNumber(value) {
  if (isNumber(value)) {
    return ("0" + value).slice(-2);
  } else {
    return "";
  }
}

export function regExpEscape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export function getDefaultValue(type: DataType): any {
  switch (type) {
    case DataType.Number:
      return 0;
    case DataType.String:
      return "";
    default:
      throw Error(`CONDICIÃN getDefaultValue = ${type} NO EVALUADA `);
  }
}

export function isValidType(type: DataType, value: any): boolean {
  switch (type) {
    case DataType.Number:
      return isNumber(value);

    case DataType.String:
      return isString(value);

    default:
      throw Error(`CondiciÃ³n isValidType = ${type} no evaluada `);
  }
}

export function assignProps(source: any, targer: any, props: string[]) {
  props.forEach(prop => {
    if (source.hasOwnProperty(prop)) {
      this[prop] = targer[prop];
      delete source[prop];
    }
  });
}

export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function isDate(obj: any): boolean {
  return !/Invalid|NaN/.test(new Date(obj).toString());
}
